export default {

  mn(state, payload) {
    state.mn = payload;
  },
  userId(state, payload) {
    state.userId = payload;
  },
  userName(state, payload) {
    state.userName = payload;
  },
  userAllowed(state, payload) {
    state.userAllowed = payload;
  },
  userIsAdmin(state, payload) {
    state.userIsAdmin = payload;
  },
  
  
};
